export default __webpack_public_path__ + "static/media/mixkit-fairy-arcade-sparkle-866.97b6dd27.wav";